import PromoterSelect from './PromoterSelect';

export default PromoterSelect;
